import React from 'react';
import documents from '../../assets/document/documents.png';
import prod from '../../assets/document/prod.png';
import "./noStudyMaterial.css";
import { useTranslation } from 'react-i18next';


function NoStudyMAterial(props) {
  const { t } = useTranslation();
  return (<>
    { props.showMsg == false &&
      <div className="up">
      
      <div className="up-container">
        { props.selectedtab == "StudyLibrary"?
        <div>
        <p className="up-text1">{t('studyMaterial.noStudyMaterialsShared')}</p>
              <img src={documents} alt=""/>
          </div>:
          <div  className="image-div">
          <p className="up-text1">{t('studyMaterial.noMaterialAvailable')}</p>
                  <img src={prod}  alt=""/>
              </div>
}

      </div>
  </div>
    }

    
</> );
}
export default NoStudyMAterial;